import Button from '@root/core/src/components/button';
import Modal from '@root/joinroot.com/src/components/modal';
import PhoneNumberInput from '@root/core/src/components/phone-number-input';
import PlatformButton from '@root/joinroot.com/src/components/platform-button';
import PropTypes from '@root/vendor/prop-types';
import React, { useState } from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import sendDownloadSms from '@root/joinroot.com/src/api/send-download-sms';
import useForm from '@root/core/src/hooks/use-form';
import { H2, Subhead } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';
import { formatPhoneNumber } from '@root/core/src/utils/strings';
import { isRequired, isValidPhoneNumber } from '@root/core/src/utils/validators';

const validations = [
  isRequired('phoneNumber', 'Please enter your phone number'),
  isValidPhoneNumber(),
];

export default function GetTheAppForm({ analytics }) {
  const [isModalShowing, setIsModalShowing] = useState(false);

  const form = useForm({
    validations,
  });

  const phoneFieldProps = form.getFieldProps('phoneNumber');

  const handleSubmit = ({ phoneNumber }) => {
    setIsModalShowing(true);
    analytics.trackClick('TEXT_ME_THE_APP_BUTTON');
    sendDownloadSms(phoneNumber);
  };

  return (
    <div css={styles.container}>
      <form
        css={styles.form}
        onSubmit={form.createSubmitHandler(handleSubmit)}
      >
        <PhoneNumberInput
          id={'phoneNumber'}
          label={'Enter your phone number'}
          {...phoneFieldProps}
        />
        <Button
          className={'button'}
          disabled={form.submitted || form.submitting}
        >
          Text me the app
        </Button>
      </form>
      <div css={styles.platformContainer}>
        <PlatformButton
          href={'https://joinroot.onelink.me/jURb/e1bd475b'}
          platform={'IOS'}
        />
        <PlatformButton
          href={'https://joinroot.onelink.me/yq3U/7065d205'}
          platform={'ANDROID'}
        />
      </div>
      <Modal
        isShowing={isModalShowing}
        name={'text-message-success-modal'}
        onClose={() => setIsModalShowing(false)}
        renderCloseButton={false}
      >
        <div css={styles.modalContent}>
          <H2 css={styles.heading}>Thanks! You should receive a text shortly.</H2>
          <Subhead css={styles.modalSubhead}>
            We sent a text message to <strong>{formatPhoneNumber(phoneFieldProps.value)}</strong> with a link to download the Root app.
          </Subhead>
          <Button onClick={() => setIsModalShowing(false)}>Okay</Button>
        </div>
      </Modal>
    </div>
  );
}

GetTheAppForm.propTypes = {
  analytics: PropTypes.shape({
    trackClick: PropTypes.func.isRequired,
  }),
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 334,
    marginTop: 50,

    'button': {
      marginTop: 30,
    },
  },
  form: {
    display: 'none',

    ...Responsive.md({
      display: 'block',
    }),
  },
  platformContainer: {
    display: 'flex',
    ...Responsive.md({
      marginTop: 30,
    }),

    '& > a + a': {
      marginLeft: 20,
    },
  },
  modalContent: {
    textAlign: 'center',
  },
  modalSubhead: {
    margin: '15px 0 40px',
  },
});
